import { type FormEvent, useState } from "react";
import { ApiError } from "../api/http";
import { api } from "../app/services";

export function KeySignIn({ onSignedIn }: { onSignedIn: () => void }) {
  const [key, setKey] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isBusy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.signInWithKey(key.trim());
      onSignedIn();
    } catch (failure) {
      setError(
        failure instanceof ApiError && failure.status === 401
          ? "That key doesn't open anything. It may have been revoked."
          : "Couldn't reach the server.",
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="gate">
      <form className="gate-card" onSubmit={submit}>
        <img src="/icon.png" alt="" className="gate-icon" />
        <h1>Radiola</h1>
        <p className="muted">
          Paste a key from the Mac app: Profile → Web player → Create Key. It signs this browser in
          to the same account.
        </p>
        <input
          type="password"
          autoComplete="off"
          spellCheck={false}
          placeholder="rdl_…"
          value={key}
          onChange={(event) => setKey(event.target.value)}
          aria-label="Access key"
        />
        {error && <p className="error">{error}</p>}
        <button type="submit" className="primary" disabled={isBusy || key.trim().length < 32}>
          {isBusy ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </main>
  );
}
